import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { StepsContainerItem } from './steps-container-item';
import { DeprecatedText } from '../../deprecated-typography';
export var stepsContainerKey = 'steps-container';
var StepsContainer = /** @class */ (function (_super) {
    __extends(StepsContainer, _super);
    function StepsContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.isReactElement = function (maybeComp) {
            return maybeComp && maybeComp.type && typeof maybeComp.type !== 'string';
        };
        _this.isStepsContainerItem = function (child) {
            if (!_this.isReactElement(child)) {
                return false;
            }
            return child.type === StepsContainerItem;
        };
        return _this;
    }
    StepsContainer.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var childrenCount = React.Children.count(props.children);
        var wrappedChildren = React.Children.map(props.children, function (child, index) {
            if (!_this.isStepsContainerItem(child)) {
                console.warn('Only children of type StepsContainerItem are expected inside StepsContainer component');
            }
            var counterValue = index + 1;
            var isLastItem = counterValue === childrenCount;
            return (React.createElement("div", { key: index, className: 'steps-container-item-container' },
                React.createElement("div", { className: 'counter-container' },
                    React.createElement(DeprecatedText, { className: 'counter', type: 't2c' }, counterValue),
                    !isLastItem && React.createElement("span", { className: 'dots' })),
                child));
        });
        return (React.createElement("div", { className: namespacedClassnames(stepsContainerKey) }, wrappedChildren));
    };
    return StepsContainer;
}(React.PureComponent));
export { StepsContainer };
//# sourceMappingURL=index.js.map